export default __webpack_public_path__ + "assets/ccbd5d07d54f4825a73647c5a9064457.jpeg";